import { Flex, Space } from "antd";
import styles from "./index.module.less";
import p2Img from "./imgs/p2_img.png";
import p3Img3 from "./imgs/p3_img3.png";
import p4Img1 from "./imgs/Marketing_pic3.png";
import p4Img2 from "./imgs/Marketing_pic4.png";
import p4Img3 from "./imgs/Marketing_pic5.png";
import p4Img4 from "./imgs/Marketing_pic6.png";
import p5Img1 from "./imgs/Marketing_pic7.png";
import p5Img2 from "./imgs/Marketing_pic8.png";
import p5Icon1 from "./imgs/p5_icon1.svg";
import p5Icon2 from "./imgs/p5_icon2.svg";
import P1Content from "@/components/P1Content";
import data from "../data";
import banner from "./imgs/p1_bg.png";

const imgMap = {
  p2Img,
  p3Img3,
  p4Img1,
  p4Img2,
  p4Img3,
  p4Img4,
  p5Img1,
  p5Img2,
};
const iconMap = {
  p5Icon1,
  p5Icon2,
};

const P3Card = ({
  title,
  desc,
  icon,
}: {
  title?: string;
  desc?: string;
  icon?: string;
}) => {
  return (
    <div className={styles.p3_card}>
      <div className={styles.p3_card_title}>{title}</div>
      <div className={styles.p3_card_desc}>{desc}</div>
      <div className={styles.p3_card_icon}>
        <img src={imgMap.p3Img3} />
      </div>
    </div>
  );
};

const P4Card = ({
  title,
  desc,
  img,
  index,
  style = {},
}: {
  title: string;
  desc: string;
  img: string;
  index: number;
  style?: React.CSSProperties;
}) => {
  return (
    <Flex vertical gap={12} className={styles.p4_card} style={style}>
      <img src={imgMap[img as keyof typeof imgMap]} />
      <div className={styles.p4_card_content}>
        <div
          className={styles.p4_card_index}
          style={{
            background:
              index == 2 ? "#16171A" : index == 4 ? "#FA8846" : "#fff",
            color: index == 2 ? "#fff" : index == 4 ? "#fff" : "#16171A",
          }}
        >
          {index < 10 ? `0${index}` : index}
        </div>
        <div className={styles.p4_card_title}>{title}</div>
        <div className={styles.p4_card_desc}>{desc}</div>
      </div>
    </Flex>
  );
};
const P5Card = ({
  title,
  desc,
  img,
}: {
  title: string;
  desc: string;
  img: string;
}) => {
  return (
    <Flex vertical gap={".2rem"} className={styles.p5_card}>
      <div className={styles.p5_card_img}>
        <img src={imgMap[img as keyof typeof imgMap]} />
        <div className={styles.p5_card_title}>{title}</div>
      </div>
      <div className={styles.p5_card_desc}>{desc}</div>
    </Flex>
  );
};

const MobileAIMarketing = () => {
  return (
    <div>
      <div className={styles.p1}>
        <P1Content
          title={data.p1.title}
          subtitle={data.p1.subtitle}
          style={{
            backgroundImage: `url(${banner})`,
          }}
        />
      </div>
      <div className={styles.p2}>
        <div className={styles.p2_inner}>
          <Flex
            align="center"
            justify="space-between"
            className={styles.p2_title}
          >
            <div>
              <div>{data.p2.title}</div>
              <div className={styles.p2_subtitle}>{data.p2.subtitle}</div>
            </div>
          </Flex>
          <div className={styles.p2_img}>
            <img src={imgMap[data.p2.img as keyof typeof imgMap]} />
          </div>
          <div className={styles.p2_desc}>{data.p2.desc}</div>
        </div>
      </div>
      <div className={styles.p3}>
        <div className={styles.p3_inner}>
          <div className={styles.p3_title}>{data.p3.title}</div>
          <div className={styles.p3_content_wrap}>
            <Flex justify="space-between" className={styles.p3_content}>
              <Flex vertical gap={".08rem"} justify="start">
                <P3Card {...data.p3.list[0][0]} />
                <P3Card {...data.p3.list[0][1]} />
              </Flex>
              <Flex vertical gap={".08rem"} justify="center">
                <P3Card {...data.p3.list[1][0]} />
                <P3Card {...data.p3.list[1][1]} />
              </Flex>
            </Flex>
          </div>
        </div>
      </div>
      <div className={styles.p4}>
        <div className={styles.p4_inner}>
          <div className={styles.p4_title}>
            {data.p4.title.split(data.p4.highlightTitle)[0]}
            <span>{data.p4.highlightTitle}</span>
          </div>
          <Flex vertical gap={".09rem"} style={{ flex: 2 }}>
            <Flex gap={".09rem"}>
              <P4Card {...data.p4.list[0]} />
              <P4Card {...data.p4.list[1]} />
            </Flex>
            <Flex gap={".09rem"}>
              <P4Card {...data.p4.list[2]} />
              <P4Card {...data.p4.list[3]} />
            </Flex>
          </Flex>
        </div>
      </div>
      <div className={styles.p5}>
        <div className={styles.p5_inner}>
          <div className={styles.p5_title}>
            {data.p5.title.split(data.p5.highlightTitle)[0]}
            &nbsp;
            <span>{data.p5.highlightTitle}</span>
          </div>
          <Flex vertical gap={".36rem"}>
            <P5Card {...data.p5.list[0]} />
            <P5Card {...data.p5.list[1]} />
          </Flex>
        </div>
      </div>
    </div>
  );
};
export default MobileAIMarketing;
